<div class="d-flex vh-100 app-layout">

  <!-- MOBILE HAMBURGER BUTTON -->
  <!-- <button class="sidebar-toggle-btn d-md-none" (click)="isSidebarOpen = !isSidebarOpen">
    <i class="fa-solid fa-bars"></i>
  </button> -->
  <header class="mobile-header d-md-none">
    <button class="sidebar-toggle-btn" (click)="toggleSidebar()">
      <i class="fa-solid fa-bars"></i>
    </button>
    <span class="mobile-title">{{ utils.companyName }}</span>
  </header>

  <!-- OVERLAY FOR MOBILE -->
  <!-- <div class="sidebar-overlay" *ngIf="isSidebarOpen" (click)="isSidebarOpen = false"></div> -->
  <div class="sidebar-overlay" *ngIf="isSidebarOpen" (click)="closeSidebar()"></div>

  <!-- SIDEBAR -->
  <nav class="sidebar p-4 d-flex flex-column" [class.open]="isSidebarOpen">
    <!-- BRAND / HEADER -->
    <div class="sidebar-header text-center mb-3">
      <img src="assets/logo.png" class="sidebar-logo mb-2" alt="SiDrive Logo">
      <h6 class="username mb-1"> {{ utils.companyName }}</h6>

      <div class="user-meta mb-2">
        <!-- <div>Company Name: {{ utils.companyName }}</div> -->
        <div>Current Round: {{ utils.round }}</div>
      </div>
      <h6 class="title">Enter your decisions</h6>
      <hr>
    </div>


    <!-- MENU -->
    <ul class="nav flex-column sidebar-menu mb-4">
      <li class="nav-item" *ngFor="let tab of tabs">
        <a class="nav-link sidebar-link" [class.text-muted]="!tab.enabled" [class.disabled]="!tab.enabled"
          [routerLink]="[tab.path]" routerLinkActive="active" (click)="!tab.enabled && $event.preventDefault()">
          {{ tab.label }}
        </a>
      </li>
    </ul>

    <!-- ACTION BUTTONS -->
    <div class="sidebar-actions mt-auto d-flex flex-column gap-2">
      <button class="action-btn save" (click)="onSave()">
        <i class="fa-solid fa-floppy-disk me-2"></i> Save
      </button>

      <button class="action-btn submit" (click)="onSubmit()">
        <i class="fa-solid fa-paper-plane me-2"></i> Submit
      </button>
    </div>

    <!-- LOGOUT BUTTON SEPARATE -->
    <div class="logout-section mt-4">
      <button class="action-btn logout w-100" (click)="onLogout()">
        <i class="fa-solid fa-right-from-bracket me-2"></i> Logout
      </button>
    </div>


  </nav>

  <!-- MAIN CONTENT -->
  <!-- <div class="flex-grow-1 content-area p-4">
    <router-outlet></router-outlet>
  </div> -->

  <!-- MAIN CONTENT -->
  <div class="flex-grow-1 content-area p-4 position-relative">

    <!-- REMARK TOGGLE (VERTICAL TAB) -->
    <div class="remark-toggle" (click)="toggleRemarkPanel()">
      Remarks
    </div>

    <!-- REMARK SIDEBAR -->
    <div class="remark-panel" [class.open]="isRemarkOpen">
      <div class="remark-header">
        <h6 class="mb-0">Remarks</h6>
        <button class="btn-close" (click)="toggleRemarkPanel()"></button>
      </div>

      <div class="remark-body">

        <ul class="remark-list" *ngIf="remarksList.length; else noRemarks">
          <li *ngFor="let item of remarksList">
            <i class="fa-solid fa-circle-info me-2"></i>
            {{ item.RoundRemark }}
          </li>
        </ul>

        <ng-template #noRemarks>
          <p class="text-muted text-center mt-4">
            No remarks available
          </p>
        </ng-template>

      </div>

    </div>

    <!-- PAGE CONTENT -->
    <router-outlet></router-outlet>

  </div>


</div>


<!-- SUBMIT CONFIRMATION TEMPLATE -->
<ng-template #submitConfirm let-modal>

  <div class="modal-header">
    <h5 class="modal-title">
      Confirm Submission
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body text-center">
    <p class="fs-6">
      Are you sure you want to submit your decisions?
    </p>

    <div class="alert alert-danger py-2">
      Once submitted, you will not be able to make changes.
    </div>
  </div>

  <div class="modal-footer justify-content-center">
    <button class="btn btn-outline-secondary" (click)="modal.dismiss()">
      Cancel
    </button>

    <button class="btn btn-success" (click)="modal.close('confirm')">
      Yes, Submit
    </button>
  </div>

</ng-template>